<template>
    <div>
        <main class="main-content">
            <div class="page-content">
          <div class="container">
            <div class="lds-ring" v-if="!isLoad"><div></div><div></div><div></div><div></div></div>
            <section class="section-limits" v-if="isLoad">
              <div class="page-title">
                <h2>Setting & Data  |  Limits</h2>
              </div>
              <div class="page-description"><p>Абзац текста с пояснением, за что эти лимиты отвечают и.т.д Tanzanian National Parks feature the richest variety of wildlife and nature in all of Africa. Let us guide you to the wonders of Tanzania, Tanzanian National Parks feature the richest variety of wildlife and nature in all of Africa.</p></div>
              <div class="settings-limits" v-if="limits.hotelLimits">
                <form action="javascript:void(0)">
                  <div class="limits-title">
                    <svg width="1em" height="1em" class="icon icon-house">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-house"></use>
                      </svg>
                      <span>Hotels</span>
                  </div>
                  <div class="limits-group">
                    <div class="limits__item">
                      <div class="form-control-group">
                        <span class="form-control-label">Hotels 3*</span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">From</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" v-model="limits.hotelLimits.hotel3.from" @input="limits.hotelLimits.hotel3.from = $event.target.value.replace(/\D/g, '');isEdit = true" class="form-control">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                      <span class="divider-limits">-</span>
                      <div class="form-control-group">
                        <span class="form-control-label"></span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">To</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.hotelLimits.hotel3.to = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.hotelLimits.hotel3.to">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="limits__item">
                      <div class="form-control-group">
                        <span class="form-control-label">Hotels 4*</span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">From</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.hotelLimits.hotel4.from = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.hotelLimits.hotel4.from">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                      <span class="divider-limits">-</span>
                      <div class="form-control-group">
                        <span class="form-control-label"></span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">To</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.hotelLimits.hotel4.to = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.hotelLimits.hotel4.to">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="limits__item">
                      <div class="form-control-group">
                        <span class="form-control-label">Hotels 5*</span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">From</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.hotelLimits.hotel5.from = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.hotelLimits.hotel5.from">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                      <span class="divider-limits">-</span>
                      <div class="form-control-group">
                        <span class="form-control-label"></span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">To</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.hotelLimits.hotel5.to = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.hotelLimits.hotel5.to">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="limits-title">
                    <svg width="1em" height="1em" class="icon icon-airplane">
                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-airplane"></use>
                    </svg>
                      <span>Flights</span>
                  </div>
                  <div class="limits-group">
                    <div class="limits__item">
                      <div class="form-control-group">
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">From</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.flightLimits.flight.from = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.flightLimits.flight.from">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                      <span class="divider-limits">-</span>
                      <div class="form-control-group">
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">To</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.flightLimits.flight.to = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.flightLimits.flight.to">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="limits-title">
                    <svg width="1em" height="1em" class="icon icon-park">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-park"></use>
                      </svg>
                      <span>Park Fees</span>
                  </div>
                  <div class="limits-group">
                    <div class="limits__item">
                      <div class="form-control-group">
                        <span class="form-control-label">Adult (F)</span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">From</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.parkFeesLimits.adultForeign.from = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.parkFeesLimits.adultForeign.from">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                      <span class="divider-limits">-</span>
                      <div class="form-control-group">
                        <span class="form-control-label"></span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">To</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.parkFeesLimits.adultForeign.to = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.parkFeesLimits.adultForeign.to">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="limits__item">
                      <div class="form-control-group">
                        <span class="form-control-label">Adult (EA)</span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">From</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.parkFeesLimits.adultEastAfrican.from = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.parkFeesLimits.adultEastAfrican.from">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                      <span class="divider-limits">-</span>
                      <div class="form-control-group">
                        <span class="form-control-label"></span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">To</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.parkFeesLimits.adultEastAfrican.to = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.parkFeesLimits.adultEastAfrican.to">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="limits__item">
                      <div class="form-control-group">
                        <span class="form-control-label">Adult (Res)</span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">From</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.parkFeesLimits.adultResidence.from = $event.target.value.replace(/\D/g, '');isEdit = true"  v-model="limits.parkFeesLimits.adultResidence.from">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                      <span class="divider-limits">-</span>
                      <div class="form-control-group">
                        <span class="form-control-label"></span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">To</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.parkFeesLimits.adultResidence.to = $event.target.value.replace(/\D/g, '');isEdit = true"  v-model="limits.parkFeesLimits.adultResidence.to">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="limits__item">
                      <div class="form-control-group">
                        <span class="form-control-label">Teenager (F)</span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">From</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.parkFeesLimits.teenagerForeign.from = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.parkFeesLimits.teenagerForeign.from">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                      <span class="divider-limits">-</span>
                      <div class="form-control-group">
                        <span class="form-control-label"></span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">To</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.parkFeesLimits.teenagerForeign.to = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.parkFeesLimits.teenagerForeign.to">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="limits__item">
                      <div class="form-control-group">
                        <span class="form-control-label">Teenager (EA)</span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">From</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.parkFeesLimits.teenagerEastAfrican.from = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.parkFeesLimits.teenagerEastAfrican.from">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                      <span class="divider-limits">-</span>
                      <div class="form-control-group">
                        <span class="form-control-label"></span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">To</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.parkFeesLimits.teenagerEastAfrican.to = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.parkFeesLimits.teenagerEastAfrican.to">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="limits__item">
                      <div class="form-control-group">
                        <span class="form-control-label">Teenager (Res)</span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">From</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.parkFeesLimits.teenagerResidence.from = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.parkFeesLimits.teenagerResidence.from">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                      <span class="divider-limits">-</span>
                      <div class="form-control-group">
                        <span class="form-control-label"></span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">To</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.parkFeesLimits.teenagerResidence.to = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.parkFeesLimits.teenagerResidence.to">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="limits__item">
                      <div class="form-control-group">
                        <span class="form-control-label">Child (F)</span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">From</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.parkFeesLimits.childForeign.from = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.parkFeesLimits.childForeign.from">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                      <span class="divider-limits">-</span>
                      <div class="form-control-group">
                        <span class="form-control-label"></span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">To</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.parkFeesLimits.childForeign.to = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.parkFeesLimits.childForeign.to">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="limits__item">
                      <div class="form-control-group">
                        <span class="form-control-label">Child (EA)</span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">From</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.parkFeesLimits.childEastAfrican.from = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.parkFeesLimits.childEastAfrican.from">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                      <span class="divider-limits">-</span>
                      <div class="form-control-group">
                        <span class="form-control-label"></span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">To</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.parkFeesLimits.childEastAfrican.to = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.parkFeesLimits.childEastAfrican.to">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="limits__item">
                      <div class="form-control-group">
                        <span class="form-control-label">Child (Res)</span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">From</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.parkFeesLimits.childResidence.from = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.parkFeesLimits.childResidence.from">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                      <span class="divider-limits">-</span>
                      <div class="form-control-group">
                        <span class="form-control-label"></span>
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">To</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.parkFeesLimits.childResidence.to = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.parkFeesLimits.childResidence.to">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="limits-title">
                    <svg width="1em" height="1em" class="icon icon-car ">
                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-car"></use>
                    </svg>
                      <span>Transfers</span>
                  </div>
                  <div class="limits-group">
                    <div class="limits__item">
                      <div class="form-control-group">
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">From</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.transferLimits.transfer.from = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.transferLimits.transfer.from">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                      <span class="divider-limits">-</span>
                      <div class="form-control-group">
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">To</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.transferLimits.transfer.to = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.transferLimits.transfer.to">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="limits-title">
                    <svg width="1em" height="1em" class="icon icon-parachute ">
                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-parachute"></use>
                    </svg>
                      <span>Activities</span>
                  </div>
                  <div class="limits-group">
                    <div class="limits__item">
                      <div class="form-control-group">
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">From</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.activityLimits.activity.from = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.activityLimits.activity.from">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                      <span class="divider-limits">-</span>
                      <div class="form-control-group">
                        <div class="form-control-group--labeled form-control-group--labeled_md">
                          <span class="form-control-label">To</span>
                          <div class="form-control-wrap form-control-wrap_with-label">
                            <input type="text" placeholder="Title" class="form-control" @input="limits.activityLimits.activity.to = $event.target.value.replace(/\D/g, '');isEdit = true" v-model="limits.activityLimits.activity.to">
                            <span class="label-inp">USD</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="limits-save-btn">
                    <button type="button" class="btn btn--green" @click="updateLimitsHandler"><span>Save</span></button>
                  </div>
                </form>
              </div>

            </section>
          </div>
        </div>
        </main>
    </div>
</template>

<script>
    import {
        getLimits,
        updateLimits
    } from '@/utilites/api'
    export default {
        data(){
            return {
                limits: {},
                isLoad: false,
				errors: false,
				isEdit: false
            }
        },
        props: ['user'],
        mounted(){
            document.title = 'Setting & Data | General | Limits'
            getLimits(this.user.access_token)
            .then(res => {
                this.isLoad = true
                this.limits = res
            })
        },
		beforeRouteLeave(to, from, next){
			if(this.isEdit){
				this.$emit('notLeaveHandler')
			}
			next()
		},
        methods: {
			checkErrors(){
				this.errors = false
				document.querySelectorAll('input.form-control').forEach(elem => {
					if(+elem.value <= 0){
						elem.parentElement.classList.add('is-error')
						this.errors = true
					}
					elem.addEventListener('focus', event => event.target.parentElement.classList.remove('is-error'))
				})
			},
            updateLimitsHandler(){
				this.checkErrors()
				if(!this.errors){
					updateLimits(this.user.access_token, this.limits)
					.then(() => {
					  	this.$emit('confirmed')
						this.isEdit = false
                	})
				}
            }
        }
    }
</script>